export default "__VITE_ASSET__1c1a7ac9__"